import { axios } from '@/utils/request'

const api = {
  supplier: '/stock/supplier',
  supplier2: '/stock/selectutils'
}

const api2 = {
  province: '/basicdata/province',
  city: '/basicdata/city',
  area: '/basicdata/area',
  street: '/basicdata/street',
  storageAccessory: '/stock/selectutils'
}

export function countSupplierPrice (parameter) {
  return axios({
    url: api.supplier2 + '/countSupplierPrice',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 配件规格
export function selectAccessorySpecification (parameter) {
  return axios({
    url: api2.storageAccessory + '/selectAccessorySpecification',
    method: 'get',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

 // 配件型号
export function selectAccessoryCategory (parameter) {
  return axios({
    url: api2.storageAccessory + '/selectAccessoryCategory',
    method: 'get',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 配件名称
export function selectAccessoryName (parameter) {
  return axios({
    url: api2.storageAccessory + '/selectAccessoryName',
    method: 'get',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 配件类型
export function selectAccessoryType (parameter) {
  return axios({
    url: api2.storageAccessory + '/selectAccessoryType',
    method: 'get',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function selectaccessory (parameter) {
  return axios({
    url: api2.storageAccessory + '/selectaccessory',
    method: 'get',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function selectAllProvince (parameter) {
  return axios({
    url: api2.province + '/selectAllProvince',
    method: 'post',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function selectCityName (parameter) {
  return axios({
    url: api2.city + '/selectCityName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getSupplierList (parameter) {
  return axios({
    url: api.supplier + '/supplierlist',
    method: 'get',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function editsupplier (parameter) {
  return axios({
    url: api.supplier + '/editsupplier',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getonesupplier (parameter) {

  return axios({
    url: api.supplier + '/getonesupplier',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function saveSupplier (parameter) {

  return axios({
    url: api.supplier +  '/addsupplier',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function delSupplier (parameter) {
  return axios({
    url: api.supplier + '/delsupplier',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}





export function forbiddenSupplier (parameter) {

  return axios({
    url: api.supplier + '/forbidden',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export const supplierExport = api.supplier + '/export'
 export const accessoryExport = api2.province + '/export'
